import { ApiService } from '@/api';
import { AddNews, News, EditNews } from '@/models/dashboard';

export const NEWS_ELEMENTS_LIMIT = 3;

export const ADMIN_NEWS_ELEMENTS_LIMIT = 10;

export class NewsApi {
  private readonly geeksBaseUrl = '/api/news';

  public async fetchNews(
    offset: number = 0,
    limit: number = NEWS_ELEMENTS_LIMIT,
  ): Promise<{ data: News[], totalCount: number }> {
    const response = await ApiService.get(
      this.geeksBaseUrl,
      {
        params: {
          offset,
          limit,
        },
      },
    );

    const data: News[] = await response.json();
    const totalCount: number = parseInt(response.headers.get('x-items-count') as string, 10);

    return new Promise((resolve) => resolve({ data, totalCount }));
  }
  public async deleteNews(news: News): Promise<void> {
    await ApiService.delete(`${this.geeksBaseUrl}/${news.id}`);
  }
  public async fetchNewsById(id: string): Promise<{ data: News}> {
    const response = await ApiService.get(`${this.geeksBaseUrl}${id}`);

    const data: News = await response.json();
    return new Promise((resolve) => resolve({ data }));
  }
  public async addNews(news: AddNews): Promise<void> {
    await ApiService.post(`${this.geeksBaseUrl}`, news);
  }
  public async editNews(id: string, news: AddNews): Promise<void> {
    await ApiService.put(`${this.geeksBaseUrl}/${id}`, news);
  }
}
